const img = 'https://oss.turingsenseai.com/1591784847070405095.png'
const content = `
<br>
<p class="ql-align-justify">
  <strong>
    100%正品，10倍赔付
  </strong>
</p>
<p class="ql-align-justify">
  采用世界最前沿的轻量级深度学习算法，以较人工1000倍的效率学习2,000,000余件真伪商品。
</p>
<p class="ql-align-justify">
  AI系统+权威鉴别师逐件查验，每日过滤千余件假货，保障交易商品100%为正品。
</p>
<p class="ql-align-justify">
  承诺假一赔三，10倍鉴别费赔付。
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    世界精英，高能团队
  </strong>
</p>
<p class="ql-align-justify">
  团队由清华大学计算机精英班“姚班”师生及互联网、奢侈品行业资深专家组成，致力于开创奢侈品二级市场全新交易体验。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  <strong>
    多重鉴别，严格质检
  </strong>
  <br />
  <img calss="custom-image" src="${img}">
  <br />
</p>
<p class="ql-align-justify">
  采用高标准成色审核及质检流程，确保商品质量、成色符合商品描述。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  <strong>
    资金监管，仓储监控
  </strong>
</p>
<p class="ql-align-justify">
  严格把关交易资金，买家确认收货无误后，卖家货款极速到账。
</p>
<p class="ql-align-justify">
  平台配备24h全程监控、恒温恒湿仓储基地，呵护每一件商品。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  <strong>
    机构护航，战略合作
  </strong>
</p>
<p class="ql-align-justify">
  与国家授权的
  <a href="https://baike.baidu.com/item/%E6%A3%80%E9%AA%8C%E6%9C%BA%E6%9E%84/1737762"
  rel="noopener noreferrer" target="_blank">
    检验机构
  </a>
  达成战略合作，为商品权威护航。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  <strong>
    唯一编号，防伪包装
  </strong>
</p>
<p class="ql-align-justify">
  每件发出商品拥有唯一鉴别编号及防伪扣；顺丰速递，安全送达。
</p>
<p class="ql-align-justify">
  &nbsp;
</p>
<p class="ql-align-justify">
  <strong>
    专业顾问，贴心客服
  </strong>
</p>
<p class="ql-align-justify">
  售前、售中、售后提供咨询和答疑服务，放心交易。
</p>
<p>
  <br>
</p>
`
export default {
  content,
  title: '平台服务说明'
}
